// /** @format */

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import theme from 'fe-appdir-lib-theme';
import { ButtonLink } from 'fe-appdir-comp-button';

const PROP_TYPES = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      type: PropTypes.oneOf(['default', 'cta', 'standard', 'primary', 'ghost']),
      href: PropTypes.string,
      to: PropTypes.string,
      gaTrackId: PropTypes.string,
    }),
  ),
};

const DEFAULT_PROPS = {
  buttons: [],
};

const Container = styled.div`
  display: flex;
  padding: ${theme.spacingMd};
  padding-top: 0;
  background-color: ${theme.colorGrey98};
`;

const AuthButton = styled(ButtonLink)`
  flex-basis: ${(props) => 100 / props.numButtons}%;
  text-align: center;
  &:not(:first-of-type) {
    margin-left: ${theme.spacingSm};
  }
`;

export const AuthButtons = ({ buttons }) => {
  const numButtons = buttons.length;
  return numButtons ? (
    <Container>
      {buttons.map((button, i) => (
        <AuthButton key={i} {...button} size="sm" numButtons={numButtons}>
          {button.label}
        </AuthButton>
      ))}
    </Container>
  ) : null;
};

AuthButtons.propTypes = PROP_TYPES;
AuthButtons.defaultProps = DEFAULT_PROPS;

export default AuthButtons;
